import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import FHM6Logo from '../assets/images/sponsors/fhm6_logo.png';
import PlayerLinkIcon from '../assets/icons/player-link.svg';
import FacebookLogo from '../assets/icons/facebook.svg';
import TwitterLogo from '../assets/icons/twitter.svg';
import RedditLogo from '../assets/icons/reddit.svg';
import CopyClipboard from '../assets/icons/copy-clipboard.svg';
import { Container } from './layout';
import { mobileBreakpoint, baseUrl, getPlayerLink, getNationalityFlag } from '../lib';

const PresentedByText = styled.p`
    margin: 0;
    font-family: 'Roboto Condensed', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-transform: uppercase;
    @media (max-width: 900px) {
        font-size: 9px;
    }
`;

const SponsorLogo = styled.img.attrs(props => ({
    src: props.src
}))`
    width:  ${props => props.isCdnSponsor ? '154px' : 'auto'};
    height: ${props => props.isCdnSponsor ? '50px' : '45px'};
    margin-left: 20px;
    @media (max-width: 900px) {
        width: ${props => props.isCdnSponsor ? '154px' : 'auto'};
        height: ${props => props.isCdnSponsor ? '50px' : '45px'};
        margin-left: 5px;
    }
`;

const TabsContainer = styled.div`
    display: flex;
`;

const Tab = styled.h3`
    font-size: 18px;
    margin-right: 25px;
    margin-bottom: 0;
    border-bottom: ${props => props.active ? '3px solid #D6001C' : '3px solid transparent'};
    cursor: pointer;
    transition: border-bottom 0.25s;
`;


const PlayerFlagContainer = styled.img.attrs(props => ({
    src: props.src
}))`
    width: ${props => props.width};
    height: ${props => props.height};
    margin-left: ${props => props.marginLeft};
`;

export const PlayerFlag = ({player, width, height, marginLeft}) => <PlayerFlagContainer src={getNationalityFlag(player.nationality)} width={width} height={height} marginLeft={marginLeft} />

const PlayerLinkIconContainer = styled.img.attrs(props => ({
    src: props.src
}))`
    margin-left: 3px;
    position: absolute;
    top: 6px;
`;

export const PlayerLink = ({player}) => <a href={getPlayerLink(player)} target="_blank" rel="noopener noreferrer"><PlayerLinkIconContainer src={PlayerLinkIcon} /></a>

export const PresentedBy = ({ logo = FHM6Logo, width, height, isCdnSponsor}) => {
    return (
        <>
            <PresentedByText>Presented By</PresentedByText>
            <SponsorLogo src={logo} width={width} height={height} isCdnSponsor={isCdnSponsor}></SponsorLogo>
        </>
    );
}

export const TabsWhenMobile = ({ children, setActiveTab, activeTab, data }) => {
    const isMobile = useMediaQuery({ maxWidth: mobileBreakpoint });
    return(
    <>
        <TabsContainer>
            {isMobile && data.map((val, id) => <Tab key={id} active={activeTab === id} onClick={()=>setActiveTab(id)}>{val}</Tab>)}
        </TabsContainer>
        <Container>
            {children.map((element, id) => 
                (!isMobile || id === activeTab) && <React.Fragment key={id}>{element}</React.Fragment>
            )}
        </Container>
    </>
    )
}

const SocialMediaIcon = styled.img.attrs(props => ({
    src: props.src
}))`
    width: ${props => props.width};
    height: ${props => props.height};
    margin-right: ${props => props.margin ? props.margin : '0px'};
    cursor: pointer;
`;

const CopyAlert = styled.div`
    width: 100px;
    color: #000000;
    font-size: 14px;
    background-color: #BABABA;
    padding: 10px 12px;
    border-radius: 4px;
    text-align: center;
    margin-left: 35px;
    opacity: ${props => props.visible ? '1' : '0'};
    transition: 0.35s opacity;
    text-transform: initial;
    font-family: Roboto;
    @media(max-width: 900px){
        width: 65px;
        font-size: 12px;
        padding: 10px 12px;
        margin-left: 25px;
    }
    position: absolute;
    top: -10px;
    left: 5px;
`;

export const SocialMediaList = ({ postId, type }) => {
    const urlInputRef = useRef(null);
    const [ copiedLink, setCopiedLink ] = useState(false);
    let url = type === 'drafts' ? `${baseUrl}/mock-draft/${postId}` : `${baseUrl}/rankings-builder/${postId}`;
    let text = type === 'drafts' ? "Check out my #NHLDraft Mock via @FCHockey's Mock Draft Builder!" : (type === 'rankings' ? "Check out my #NHLDraft Rankings via @FCHockey's Rankings Builder!" : "Check out my #NHLDraft Report");
    if(type === 'reports') url = postId;

    useEffect(() => {
        if(copiedLink) {
            let hideAlert = setTimeout(()=> setCopiedLink(''), 2000);
            return () => { clearTimeout(hideAlert) };
        }
    }, [copiedLink]);

    function copyText(e) {
        urlInputRef.current.select();
        document.execCommand('copy');
        e.target.focus();
        setCopiedLink(true);
     }

    return <div style={{display: 'flex', alignItems: 'center', position: 'relative'}}>
        <input ref={urlInputRef} type="text" value={url} style={{position: 'absolute', left: '-99999px'}}/>
        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(text)}`}
           target="_blank" rel="noopener noreferrer"><SocialMediaIcon src={FacebookLogo} margin="20px" width="11px"
                                                                      height="19px"></SocialMediaIcon></a>
        <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`}
           target="_blank" rel="noopener noreferrer"><SocialMediaIcon src={TwitterLogo} margin="20px" width="20px"
                                                                      height="16px"></SocialMediaIcon></a>
        <a href={`http://www.reddit.com/submit?url=${(url)}`} target="_blank" rel="noopener noreferrer"><SocialMediaIcon
            src={RedditLogo} margin="20px" width="22px" height="20px"></SocialMediaIcon></a>
        <button
            style={{position: 'relative', border: 'none', background: 'none', cursor: 'pointer'}}
            onClick={copyText}
        >
            <SocialMediaIcon src={CopyClipboard} width="23px" height="23px"/>
            <CopyAlert visible={copiedLink}>Link copied!</CopyAlert>
        </button>
    </div>
}